import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true
});

let refreshing = null;
api.interceptors.response.use(null, async error => {
  const original = error.config;
  const url = original?.url || "";
  const skip = ["/auth/login", "/auth/refresh", "/auth/logout"].includes(url);
  if (error.response?.status !== 401 || !original || original._retry || skip) throw error;
  original._retry = true;
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  await refreshing;
  return api(original);
});

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return typeof detail.msg === "string" ? detail.msg : String(detail);
}

export const ROLE_LABEL = { admin: "Administrator", maker: "Operations maker", checker: "Finance checker" };
